import { BackLink, Button, Header } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import passwordChangeSuccess from '../../../shared/assets/password-change-success.svg';

const ChangePasswordSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="relative flex justify-center">
      <div className="max-w-[680px] w-full mx-auto h-full pt-0 p-6">
        <div className="mb-6">
          <BackLink onBack={() => navigate('/account')} text={t('common.buttons.backToMyAccount')} />
        </div>
        <div className="flex flex-col gap-[30px]">
          <Header level="h2">{t('page.account.changePasswordSuccess.title')}</Header>
          <img alt="Success illustration" className="w-full h-auto mx-auto" src={passwordChangeSuccess} />
          <Button className="w-full" onClick={() => navigate('/account')}>
            {t('page.account.changePasswordSuccess.button')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export { ChangePasswordSuccess };
